import { useState } from "react";

function Tabs({ filterCategory, tabsData }) {
  const [active, setActive] = useState("all");

  const handleClick = (category) => {
    setActive(category);
    filterCategory(category);
  };

  return (
    <div className="text-center my-4">
      {tabsData.map((category, index) => (
        <li
          key={index}
          onClick={() => handleClick(category)}
          className={active === category ? "filter-active1" : ""}
          style={{ display: "inline-block", cursor: "pointer", margin: "0 10px", listStyle: "none" }}
        >
          {category}
        </li>
      ))}
    </div>
  );
}

export default Tabs;
